module.exports = __webpack_public_path__ + "static/media/bradesco.76bf5d5d.png";